import { get, post } from "@/utils";

export const GET_RECHARGELSIT = () => new Promise(async (resolve, reject) => {
  try {
    const res = await get("/pay/lists");
    resolve(res)
  } catch (error) {
    reject(error)
  }
})

export const PAY_SUBMIT = (params) => new Promise(async (resolve, reject) => {
  try {
    const res = await get("/pay/submit", params);
    resolve(res)
  } catch (error) {
    reject(error)
  }
})

export const GET_RECHARGEORDER = (params) => new Promise(async (resolve, reject) => {
  try {
    const res = await post("/pay/record", params)
    resolve(res)
  } catch (error) {
    reject(error)
  }
})

export const GET_WITHDRAW_RECORD = (params) => new Promise(async (resolve, reject) => {
  try {
    const res = await get("/users/extract/record", params);
    resolve(res)
  } catch (error) {
    reject(error)
  }
})

export const GET_UNITDATA = (params) => new Promise(async (resolve, reject) => {
  try {
    const res = await get("/third/currency/rate", params);
    resolve(res)
  } catch (error) {
    reject(error)
  }
})

export const GET_UNIDATACHILDREN = (code = '') => new Promise(async (resolve, reject) => {
  try {
    const res = await post("/third/currency/type", { code });
    resolve(res)
  } catch (error) {
    reject(error)
  }
})

export const ADD_BANK = (params) => new Promise(async (resolve, reject) => {
  try {
    const res = await post("/users/bank/add", params);
    resolve(res)
  } catch (error) {
    reject(error)
  }
})
export const GET_BANKLIST = (params) => new Promise(async (resolve, reject) => {
  try {
    const res = await post("/users/bank", params);
    resolve(res)
  } catch (error) {
    reject(error)
  }
})

export const DEL_BANK = (params) => new Promise(async (resolve, reject) => {
  try {
    const res = await post("/users/bank/del", params);
    resolve(res)
  } catch (error) {
    reject(error)
  }
})

export const WITHDRAW = (params) => new Promise(async (resolve, reject) => {
  try {
    const res = await post("/users/extract", params);
    resolve(res)
  } catch (error) {
    reject(error)
  }
})

export const TRANSACTION_PASSWORD = (params) => new Promise(async (resolve, reject) => {
  try {
    const res = await get('/users/edit/paypass', params);
    resolve(res)
  } catch (error) {
    reject(error)
  }
})

export const EDITPASS = (params) =>  new Promise(async (resolve, reject) => {
  try {
    const res = await get("/users/edit/userpass", params);
    resolve(res)
  } catch (error) {
    reject(error)
  }
})